<template>
  <v-container class="mfa-container">
    <authentication-methods v-show="!isMFAComplete" :isMfaView="true"></authentication-methods>
  </v-container>
</template>

<script lang="ts">
import Vue from "vue";
import AuthenticationMethods from "@/components/MFA/AuthenticationMethods.vue";

import { RootStoreInterface } from "@/store/types";
import { createHelpers } from "vuex-typescript-interface";

const { mapGetters } = createHelpers<RootStoreInterface>();

const getters = mapGetters(["getMfaComplete"]);

export default Vue.extend({
  name: "mfaComponent",
  components: {
    AuthenticationMethods,
  },
  computed: {
    ...getters, 
    isMFAComplete(): boolean  {
      return this.getMfaComplete;
    }
  }
});
</script>
<style lang="scss" scoped>
.mfa-container {
  width: 420px;
  max-width: 100%;
}
</style>
